import Images from 'images';

// The platform's name and mark for brand wording in Forms (T40): "Live in
// the Pit Pay app", "Ticket Hoss account info". Read at call time so tests
// can switch REACT_APP_PLATFORM per case.
export const brand = () => {
  const platform = process.env.REACT_APP_PLATFORM;
  if (platform === 'tickethoss') {
    return { name: 'Ticket Hoss', mark: Images.ticketHossCollapsedLogo };
  }
  if (platform === 'kartpass') {
    return { name: 'Kart Pass', mark: Images.pitpayCollapsedLogo };
  }
  return { name: 'Pit Pay', mark: Images.pitpayCollapsedLogo };
};

export default brand;
